import { Routes } from '@angular/router';
import { NotFound } from './core/components/not-found/not-found';
import { ForbiddenComponent } from './core/components/forbidden/forbidden';
import { authGuard } from './core/guards/auth-guard';

export const routes: Routes = [
  {
    path: 'admin',
    loadChildren: () => import('./features/auth/auth-module').then((m) => m.AuthModule),
  },
  {
    path: 'merchant',
    loadChildren: () => import('./features/auth/auth-module').then((m) => m.AuthModule),
  },
  {
    path: '',
    loadChildren: () => import('./features/layout/layout-module').then((m) => m.LayoutModule),
   canActivate: [authGuard],
  },
  {
    path: 'forbidden',
    component: ForbiddenComponent,
  },
  {
    path: '**',
    component: NotFound,
  },
];
